import {windowHeight} from './windowHeight';

export const defaultPositionY = (height: number): number => windowHeight() - height;
